import React from "react";
import { Box, Modal, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { STANDARD_MODAL_SURFACE_SX } from "../../../utils/formModalStyles";

const WorkflowPanelModal = ({ open, onClose, title, children, width = { xs: "95%", sm: 560 } }) => (
  <Modal open={open} onClose={onClose}>
    <Box
      sx={{
        ...STANDARD_MODAL_SURFACE_SX,
        width,
        p: 3,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1, textAlign: "center" }}>
          {title}
        </Typography>
        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ my: 1.5 }} />
      {children}
    </Box>
  </Modal>
);

export default WorkflowPanelModal;
